import { Component } from '@angular/core';
import { ThemeService } from '../shared/theme.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
})
export class NavigationComponent {
  menuOpen = false;

  links = [
    { href: '#about', label: 'About' },
    { href: '#awards', label: 'Certifications' },
    { href: '#skills', label: 'Skills' },
    { href: '#chess', label: 'Chess' },
  ];

  constructor(public theme: ThemeService) {}

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }
}
